<template>
  <div class="wrapper">
    <Tabs @on-click="tabChange" :value="labelMsg">
      <TabPane label="帮助中心" name="hep">
        <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border
          style="width:100%;margin:10px 0;">
          <template slot-scope="{ row }" slot="content">
            <div v-html="row.content"></div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button type="info" @click="$router.push('statisticalLearning/details?id=' + row.id)"
              size="small">详情</Button>
          </template>
        </Table>
        <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
          :current="tableData.current_page" show-total @on-change="getData" />
      </TabPane>
      <TabPane label="关于我们" name="abou">
        <div class="div" v-html="lineObj.about_us"></div>
      </TabPane>
      <TabPane label="联系我们" name="cont">
        <div class="div" v-html="lineObj.contact_us"></div>
      </TabPane>
      <TabPane label="平台信息" name="app">
        <Row>
          <Col span="8">
          <a class="box" :href="schoolInfo.h5_url" target="_blank">
            <div class="qrcode" ref="h5QR"></div>
            <p>H5端访问链接</p>
          </a>
          </Col>
          <Col span="8">
          <a class="box" :href="path + schoolInfo.app_url" download>
            <div class="qrcode" ref="appQR"></div>
            <p>下载安卓端安装包</p>
          </a>
          </Col>
          <Col span="8">
          <div class="box">
            <img :src="path + schoolInfo.miniapp_qrcode" alt="">
            <p>微信小程序二维码</p>
          </div>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
    <!-- <Modal v-model="lookShow" @on-cancel="lookShow = false" :title="looksInfo.title">
      <div v-html="looksInfo.content"></div>
      <div slot="footer">
        <Button type="text" size="small" @click="lookShow = false">取消</Button>
      </div>
    </Modal> -->
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  import { mapState } from 'vuex'
  import QRCode from 'qrcodejs2'
  export default {
    components: {},
    mixins: [indexPage],
    data() {
      return {
        lookShow: false,
        looksInfo: {},
        schoolInfo: {},
        tableColumns: [
          { title: "ID", key: "id", align: "center", width: 80 },
          { title: "标题", key: "title", align: "left" },
          { title: "内容", slot: "content", align: "left" },
          { title: "操作", slot: "action", align: "center" },
        ],
        lineObj: {},
        indexUrl: "/app/helpus/index",
      }
    },
    computed: {
      ...mapState({
        labelMsg(state) {
          return state.global.labelMsg;
        },
      })
    },
    mounted() {
      this.getline()
    },
    methods: {
      contentCli(row) {
        this.looksInfo = {}
        this.lookShow = true
        this.looksInfo = row
      },
      getline() {
        this.$axios
          .post('/app/auth/getWebInfo')
          .then((res) => {
            if (res.code == 1) {
              this.lineObj = res.data
            } else {
              this.$Message.error(res.msg);
            }
          });

        this.$axios
          .post('/app/school/info')
          .then((res) => {
            if (res.code == 1) {
              this.schoolInfo = res.data
              this.creatQrCode();
            } else {
              this.$Message.error(res.msg);
            }
          });
      },
      creatQrCode() {
        new QRCode(this.$refs.h5QR, {
          text: this.schoolInfo.h5_url, // 转换为二维码的内容
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        new QRCode(this.$refs.appQR, {
          text: `https:${this.path}${this.schoolInfo.app_url}`, // 转换为二维码的内容
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      },
      tabChange(name) {
        this.$store.commit('global/SET_LABEL_MSG', name)
      }
    }
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 100%;
    min-height: 72vh;
    padding: 10px;
    .div {
      padding: 0 10px;
    }
    .box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      img {
        width: 200px;
        height: 200px;
      }
      .qrcode {
        width: 200px;
        height: 200px;
        /deep/img {
          width: 100%;
          height: 100%;
        }
      }
      p,
      a {
        font-size: 20px;
        color: #000;
        font-weight: 550;
        margin-top: 30px
      }
      &:hover p {
        cursor: pointer;
        color: #57a3f3 !important;
      }
    }
    //   .constent{
    //   width: 100%;
    //   max-height: 600px;
    //   overflow-y: auto;
    //   line-height: 1.6!important;
    // }
    // .constent >>> * {
    //   max-width: 99%;
    //   margin-left: 0.3%;
    //   height: auto;
    //   /* white-space: nowrap; */
    //   /* display: inline-block; */
    // }
    // .constent >>> img {
    //   width: 100vw!important;
    //   height:auto!important;
    // }
    // .constent >>> p {
    //   line-height: 2!important;
    //   /* white-space: nowrap; */
    //   /* display: inline-block; */
    // }
  }
</style>
